/*Questo modulo si occupt di recuperare le informazioni generali del gateway*/
import Vue from "vue";
import {
  InfoService,
} from "@/common/api.service";

const initialState = {
  infos: null,
  loading: false,
};

export const state = { ...initialState };

export const actions = {
  async fetchInfo(context) {
    context.commit("setLoading", true);
    console.log("Fetching info settings...")
    const { data } = await InfoService.get();
    context.commit("setInfo", data);
    context.commit("setLoading", false);
    return data;
  }
};


export const mutations = {
  setInfo(state, data) {
    state.infos = data;
  },
  setLoading(state, data) {
    state.loading = data;
  }
};

export default {
  namespaced: true,
  state,
  actions,
  mutations
};
